module.exports = __webpack_public_path__ + "img/logo-sm.8f5cf942.png";